// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__7L3XF","Success":"Button_Success__E6pOI","Danger":"Button_Danger__1QUYQ"};